/* eslint-disable @next/next/no-sync-scripts */
import NextHead from 'next/head';

import tailwindConfig from '@modules/utils/tailwind-config';

const favoriteColor = tailwindConfig.theme.colors.favorite;

export const Head = (): JSX.Element => (
  <NextHead>
    <meta charSet="utf-8" />
    <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    {/* eslint-disable-next-line @next/next/no-css-tags */}

    <meta name="MobileOptimized" content="320" />
    <meta name="HandheldFriendly" content="true" />
    <meta name="referrer" content="no-referrer-when-downgrade" />

    <meta name="author" content="Hitechline Tecnologia LTDA" />
    <meta name="theme-color" content={favoriteColor} />

    <link rel="manifest" href="/manifest.webmanifest" />

    <meta name="msapplication-TileColor" content={favoriteColor} />
    <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />

    <link rel="icon" type="image/x-icon" href="/icons/favicon.ico" />
    <link rel="shortcut icon" type="image/x-icon" href="/icons/favicon.ico" />

    <link
      rel="icon"
      type="image/png"
      sizes="16x16"
      href="/icons/favicon-16x16.png"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="32x32"
      href="/icons/favicon-32x32.png"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="96x96"
      href="/icons/favicon-96x96.png"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="192x192"
      href="/icons/favicon-192x192.png"
    />

    <link
      rel="apple-touch-icon"
      sizes="57x57"
      href="/icons/apple-icon-57x57.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="60x60"
      href="/icons/apple-icon-60x60.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="72x72"
      href="/icons/apple-icon-72x72.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="76x76"
      href="/icons/apple-icon-76x76.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="114x114"
      href="/icons/apple-icon-114x114.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="120x120"
      href="/icons/apple-icon-120x120.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="144x144"
      href="/icons/apple-icon-144x144.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="152x152"
      href="/icons/apple-icon-152x152.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="/icons/apple-icon-180x180.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="192x192"
      href="/icons/apple-icon-192x192.png"
    />

    <script
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PKQLLVT');
        `,
      }}
    />
  </NextHead>
);
